export const getFieldValuesAsOptions = (jsonArray: any[], fieldPath: string): { name: string }[] =>
  jsonArray.map((item) => getFieldValueAsOption(item, fieldPath)).filter((item) => item)

export function getFieldValueAsOption(item: any, fieldPath: string): { name: string; item: any } {
  const pathParts = fieldPath.substring(2).split('.')
  let value = item

  for (const part of pathParts)
    if (value && part in value) value = value[part]
    else return null

  return { name: value, item }
}
